import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const AvatarContainer = styled(FlexDiv)`
    border-radius: 50%;
    background-color: #e6f4ff;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
`